<template>
  <div class="">
    <order-list type="selffetch"></order-list>
  </div>
</template>
<script>

import OrderList from "@/components/Order/OrderList";
export default {
  components: {
    OrderList
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
  },
  computed: {},
  methods: {
  }
};
</script>
<style scoped>
</style>
